import React from "react";
import Header from "../HomeHeader/Header";
import { NavLink } from "react-router-dom";
import "./Report.css";
export default function Report() {
  return (
    <div>
      <Header />
      <nav
        className="navbar-expand-lg navbar-light bg-light"
        style={{ padding: "5px" }}
      >
        <ul className="navbar-nav" style={{ gap: "10px" }}>
          <li className="nav-item">
            <NavLink id="num" to="/reportTree">
              Register
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink id="num" to="/scheduleInfo">
              ScheduleInfo
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink id="num" to="/assetLog">
              AssetLog
            </NavLink>
          </li>
          {/* <li className="nav-item">
            <NavLink id="num" to="/online">
              Online
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink id="num" to="/offline">
              Offline
            </NavLink>
          </li> */}
        </ul>
      </nav>
    </div>
  );
}
